import { create } from 'zustand';
import { WorkData } from '../dto/EntityRepository';

/** 마퀴 선택 박스와 겹치는 Work (리스트 표시 순, DOM 순) */
interface WorkListMarqueeState {
  hitWorks: WorkData[];
  setHitWorks: (works: WorkData[]) => void;
  clearHitWorks: () => void;
}

function sameWorksByIdOrder(a: WorkData[], b: WorkData[]): boolean {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    if (String(a[i].id) !== String(b[i].id)) return false;
  }
  return true;
}

export const useWorkListMarqueeStore = create<WorkListMarqueeState>((set, get) => ({
  hitWorks: [],
  setHitWorks: (works) => {
    const next = works;
    if (sameWorksByIdOrder(next, get().hitWorks)) return;
    set({ hitWorks: next });
  },
  clearHitWorks: () => {
    if (get().hitWorks.length === 0) return;
    set({ hitWorks: [] });
  },
}));
